
import Vue from "vue";
import AppTicketStatusSelect from "@/components/ticket/TicketStatusSelect.vue";
import AppDepartmentSelect from "@/components/DepartmentSelect.vue";
import AppCompanyEmployeeSelect from "@/components/company/CompanyEmployeeSelect.vue";
import {ISelectItem} from "winfakt-vue-components";
import {TicketPlannedStatus} from "@/utils/ticket-planned-status";
import { AttentionGiven, TicketFilters } from "@/utils/ticket-filters";
import {Tier} from "@/utils/tier";
import { Admin } from "@/models/admin";
import { AdminsService } from "@/services";

export default Vue.extend({
	data(){
		return {
			quickFilters: new TicketFilters(),
			admins: [] as Admin[]
		};
	},
	props: {
		value: {
			type: Object as () => TicketFilters,
			required: true
		}
	},
	computed: {
		readItems(): ISelectItem<boolean | undefined>[] {
			return [
				{
					text: "Allen",
					value: undefined
				},
				{
					text: "Gelezen",
					value: true
				},
				{
					text: "Ongelezen",
					value: false
				}
			];
		},
		tierItems(): ISelectItem<number | undefined>[] {
			return [
				{
					text: "Free",
					value: Tier.Free
				},
				{
					text: "Starter",
					value: Tier.Starter
				},
				{
					text: "Professional",
					value: Tier.Pro
				},
				{
					text: "Prof PLUS",
					value: Tier.ProfessionalPlus
				},
				{
					text: "Enterprise",
					value: Tier.Enterprise
				}
			];
		},
		plannedStatusItems(): ISelectItem<TicketPlannedStatus>[] {
			return [
				{
					text: "Niet van toepassing",
					value: TicketPlannedStatus.None
				},
				{
					text: "Ja",
					value: TicketPlannedStatus.Planned
				},
				{
					text: "Vandaag",
					value: TicketPlannedStatus.PlannedToday
				},
				{
					text: "Tot en met vandaag",
					value: TicketPlannedStatus.UntilToday
				}
			];
		},
		demoItems(): ISelectItem<boolean | undefined>[] {
			return [
				{
					text: "Niet van toepassing",
					value: undefined
				},
				{
					text: "Demo",
					value: true
				},
				{
					text: "Geen Demo",
					value: false
				}
			];
		},
		freeItems(): ISelectItem<boolean | undefined>[] {
			return [
				{
					text: "Niet van toepassing",
					value: undefined
				},
				{
					text: "Free",
					value: true
				},
				{
					text: "Geen free",
					value: false
				}
			];
		},
		attentionsToolTip(): string {
			return "Toon enkel de tickets die naar mijn attentie vragen.";
		},
		demoToolTip(): string {
			return "Filter al dan niet op Demo tickets";
		},
		freeToolTip(): string {
			return "Filter al dan niet op Free tickets";
		},
		attentionGivenItems():ISelectItem<AttentionGiven>[]{
			return [
				{
					text: "Niet van toepassing",
					value: AttentionGiven.DISABLED
				},
				{
					text: "Alle gegeven attenties",
					value: AttentionGiven.ON
				},
				{
					text: "Alle gegeven ongelezen attenties",
					value: AttentionGiven.ON_AND_UNREAD
				}
			];
		},
		adminItems():ISelectItem<number>[]{
			return this.admins.map(a=>{
				return {
					text: a.name,
					value: a.id
				};
			});
		}
	},
	watch: {
		value: {
			deep: true,
			immediate: true,
			handler(){
				this.quickFilters = new TicketFilters(this.value.toJSON());
			}
		}
	},
	methods: {
		close() {
			this.$emit("close");
		},
		cancel(){
			this.close();
		},
		save(){
			this.$emit("input", this.quickFilters);
			this.close();
		}
	},
	async mounted() {
		this.admins = await AdminsService.getAdmins();
	},
	components: {
		AppTicketStatusSelect,
		AppDepartmentSelect,
		AppCompanyEmployeeSelect
	}
});
